'use strict';

angular.module('userRequestEditControllers')

.directive('systemAndRoles', [function () {
    return {
        scope: {
            system: '=',
            systemRoles: '=',
            accessRequest: '=',
            getAllRoles: '@'
        },
        templateUrl: require('./systemAndRoles.tpl.html'),
        controller: ['$scope', '$modal', '$state', function ($scope, $modal, $state) {

            // System roles chooser modal
            $scope.withShowSystemRoles = function () {
                return $scope.accessRequest.IsEditable;
            }

            $scope.showSystemRoles = function () {

                if (!$scope.withShowSystemRoles()) return;

                var modalScope = $scope.$new(true);
                modalScope.userRequest = $scope.accessRequest;
                modalScope.system = $scope.system;
                modalScope.systemRoles = $scope.systemRoles;
                modalScope.getAllRoles = $scope.getAllRoles;
                modalScope.withChanges = false;

                var chooserSysRoleModal = $modal({
                    scope: modalScope,
                    template: require('./selectSystemRolesModal.tpl.html'),
                    placement: 'center'
                });

                modalScope.hideModal = function () {
                    $state.go($state.current, {}, { reload: true });
                    chooserSysRoleModal.$promise.then(chooserSysRoleModal.hide);
                }

                modalScope.okModal = function () {
                    modalScope.hideModal();
                }
            }
        }],
        link: function ($scope, element, attrs) {

        }
    };
}]);
